import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/storage/store.ts'
import { RequestError } from '@/common/types_and_interfaces.ts'
import {
  GETProgramSettings,
  GetProgramSettingsEndpoint,
  ProgramSettingsResp,
} from '@/storage/program_settings/requests.ts'

const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState
  dispatch: AppDispatch
  rejectValue: RequestError
}>()

export const FetchProgramSettings = createAppAsyncThunk<
  ProgramSettingsResp,
  number
>(GetProgramSettingsEndpoint, async function (programId, thunkAPI) {
  const response = await GETProgramSettings(programId)

  if (response.error) {
    return thunkAPI.rejectWithValue(response.error)
  }
  return response.data
})
